/** ProposalHeader — symbol, quote strip, versions/rerun controls. */
import { ArrowLeft, Loader2, GitBranch, RefreshCcw } from "lucide-react";

export default function ProposalHeader({
  prop, versions, onBack, onToggleCompare, onRerun, rerunning,
}) {
  const a = prop.analyst || {};
  const q = prop.market_snapshot || {};
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <button className="btn-ghost" onClick={onBack} data-testid="proposal-back-btn" aria-label="Back">
        <ArrowLeft size={14}/> Back
      </button>
      <div className="mono text-xl">{prop.symbol}</div>
      <div className="text-xs mono text-muted-foreground uppercase tracking-widest">
        Quote ${q.price?.toFixed?.(2)} · {q.provider?.toUpperCase()} · {q.feed_quality?.toUpperCase()} · Regime {(a.regime || "-").toUpperCase()}
      </div>
      {prop.analysis_meta?.verdict && (
        <span className="chip !text-[10px] border-current text-signal-green">{prop.analysis_meta.verdict}</span>
      )}
      {prop.analysis_meta?.opportunity_score !== undefined && prop.analysis_meta?.opportunity_score !== null && (
        <span className="mono text-[10px] text-muted-foreground uppercase tracking-widest">Score {prop.analysis_meta.opportunity_score}</span>
      )}
      <div className="ml-auto flex items-center gap-2 flex-wrap">
        <span className="text-[10px] mono uppercase text-muted-foreground">Critic Rec</span>
        <span className="mono text-sm">{(prop.consensus || {}).recommended_plan_id || "—"}</span>
        {versions.length > 1 && (
          <button className="btn-outline h-8 !px-2 text-[11px]" onClick={onToggleCompare} data-testid="proposal-versions-btn" aria-label={`View version history — currently v${prop.version} of ${versions.length}`}>
            <GitBranch size={12}/> v{prop.version} of {versions.length}
          </button>
        )}
        <button
          className="btn-outline h-8 !px-2 text-[11px]"
          onClick={onRerun}
          disabled={rerunning || prop.status === "executed" || prop.status === "closed"}
          data-testid="proposal-rerun-btn"
          aria-label="Rerun AI debate"
        >
          {rerunning ? <Loader2 size={12} className="animate-spin"/> : <RefreshCcw size={12}/>} Rerun
        </button>
      </div>
    </div>
  );
}
